import React from 'react'

const RecipeDescription = (props) => 
    <p className="short-description">{props.recipe.description}</p>

export default RecipeDescription